export default __webpack_public_path__ + "static/honeycomb-green-62add1d6379998787dab6c73ebe4b7cf.png";